import React, { useEffect, useRef } from 'react'
import styles from './AutoExpandingTextarea.module.css'

const ATA = ({ myText, change, redBorder }) => {
  const textareaRef = useRef(null)

  const autoResize = () => {
    const textarea = textareaRef.current
    textarea.style.height = 'auto'
    textarea.style.height = `${textarea.scrollHeight}px`
  }

  useEffect(() => {
    autoResize()
  }, [myText])

  return (
    <textarea
      ref={textareaRef}
      onInput={autoResize}
      onChange={change}
      value={myText}
      style={
        redBorder ? { resize: 'none', borderColor: 'red' } : { resize: 'none' }
      }
      className={styles.notesText}
    />
  )
}
export default ATA
